import { Component } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-file-upload',
  templateUrl: './formly-file-upload.component.html',
  styleUrl: './formly-file-upload.component.scss',
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem],
})
export class FormlyFileUploadComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: {
      btnClass: 'info text-white',
      iconClass: 'fa fa-file-upload',
      text: $localize`Import`,
      dropdownIconClass: 'fa fa-file-download',
    },
  };

  select(file: HTMLInputElement) {
    if (this.props.select) {
      this.props.select(file.files[0]);
      file.value = null;
    }
  }

  dropdown() {
    this.props.dropdown();
  }
}
